import React from 'react'
import { Button, Modal } from '../../../../components'


const QbModal = ({open, onClose }) => {
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title="ALERT"
      width="max-w-2xl"
    >
      <div className=" flex flex-col items-center justify-center gap-4">
          <p>Invoice #16464 successfully updated to Quick Books.</p>
        <div className="flex justify-end gap-3 mt-6">
          <Button title={"Close"} onClick={onClose} />
        </div>
      </div>
    </Modal>
  )
}

export default QbModal
